import marketingCampaigns from './MarketingCampaigns.view';

export default marketingCampaigns;